import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";

const StickySaveButton = ({
  label = "Save",
  loading = false,
  disabled = false,
  open = false,          // sidebar open/close
  onClick,
  type = "submit",
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        padding: "10px 0",
        zIndex: 1000,
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: "transparent",
      }}
    >
      <Button
        type={type}
        onClick={onClick}
        variant="contained"
        disabled={disabled || loading}
        sx={{
          width: "168px",
          ml: open ? "18.5%" : "7.2%",
          height: "48px",
          borderRadius: "8px",
          fontSize: "16px",
          fontWeight: 600,
          textTransform: "none",
          fontFamily: "figtree",
          transition: "all 0.35s ease",

          backgroundColor:
            disabled || loading ? "#c7c7f5" : "#5751E9",

          "&:hover": {
            backgroundColor:
              disabled || loading ? "#c7c7f5" : "#4b45d6",
          },

          "&.Mui-disabled": {
            cursor: "not-allowed",
            backgroundColor: "var(--app-border)",
            color: "var(--app-text-muted)",
          },
        }}
      >
        {loading ? (
          <CircularProgress size={20} sx={{ color: "#fff" }} />
        ) : (
          label
        )}
      </Button>
    </Box>
  );
};

export default StickySaveButton;
